<template>
  <section class="page-block barbers-block" id="barbers-block">
    <div class="wide">
      <div class="mid">
        <div class="title">
          <!-- <div id="bm-barbers"></div> -->
          <lottie
            id="bm-barbers"
            :options="defaultOptions"
            v-on:animCreated="handleAnimation"
          />
          <h2>{{ $t('BarbersBlock.Title') }}</h2>
        </div>
        
        <div class="list owners">
          <div
            class="barber ivan bias-n10"
            @click="$emit('click-barbers-pop'), NavNum = 0, changeNavNum()"
          >
            <img src="@/content/barbers/ovcharenko.png" />
            <span></span>
            <label>{{ $t('BarbersBlock.Barbers.A') }}&nbsp;{{ $t('BarbersBlock.Barbers.Alast') }}</label>
          </div>
          <div
            class="barber maxim bias-0"
            @click="$emit('click-barbers-pop'), NavNum = 1, changeNavNum()"
          >
            <img src="@/content/barbers/mylik.png" />
            <span></span>
            <label>{{ $t('BarbersBlock.Barbers.B') }}&nbsp;{{ $t('BarbersBlock.Barbers.Blast') }}</label>
          </div>
        </div>
        
        <div class="list">
          <div
            class="barber bias-n5"
            @click="$emit('click-barbers-pop'), NavNum = 2, changeNavNum()"
          >
            <img src="@/content/barbers/andreev.png" />
            <span></span>
            <label>{{ $t('BarbersBlock.Barbers.C') }}&nbsp;{{ $t('BarbersBlock.Barbers.Clast') }}</label>
          </div>
          <div
            class="barber bias-p5"
            @click="$emit('click-barbers-pop'), NavNum = 3, changeNavNum()"
          >
            <img src="@/content/barbers/patlan.png" />
            <span></span>
            <label>{{ $t('BarbersBlock.Barbers.D') }}&nbsp;{{ $t('BarbersBlock.Barbers.Dlast') }}</label>
          </div>
          <div
            class="barber bias-n5"
            @click="$emit('click-barbers-pop'), NavNum = 4, changeNavNum()"
          >
            <img src="@/content/barbers/shinkarenko.png" />
            <span></span>
            <label>{{ $t('BarbersBlock.Barbers.E') }}&nbsp;{{ $t('BarbersBlock.Barbers.Elast') }}</label>
          </div>
          
          <div
            class="barber bias-n10"
            @click="$emit('click-barbers-pop'), NavNum = 5, changeNavNum()"
          >
            <img src="@/content/barbers/bryantsev.png" />
            <span></span>
            <label>{{ $t('BarbersBlock.Barbers.G') }}&nbsp;{{ $t('BarbersBlock.Barbers.Glast') }}</label>
          </div>

          <div
            class="barber bias-p5"
            @click="$emit('click-barbers-pop'), NavNum = 6, changeNavNum()"
          >
            <img src="@/content/barbers/kniupa.png" />
            <span></span>
            <label>{{ $t('BarbersBlock.Barbers.H') }}&nbsp;{{ $t('BarbersBlock.Barbers.Hlast') }}</label>
          </div>

          <div
            class="barber bias-p5"
            @click="$emit('click-barbers-pop'), NavNum = 7, changeNavNum()"
          >
            <img src="@/content/barbers/kovalenko.png" />
            <span></span>
            <label>{{ $t('BarbersBlock.Barbers.I') }}&nbsp;{{ $t('BarbersBlock.Barbers.Ilast') }}</label>
          </div>

          <div
            class="barber bias-p10"
            @click="$emit('click-barbers-pop'), NavNum = 8, changeNavNum()"
          >
            <img src="@/content/barbers/bogoboyashy.png" />
            <span></span>
            <label>{{ $t('BarbersBlock.Barbers.J') }}&nbsp;{{ $t('BarbersBlock.Barbers.Jlast') }}</label>
          </div>

          <div
            class="barber bias-p5"
            @click="$emit('click-barbers-pop'), NavNum = 9, changeNavNum()"
          >
            <img src="@/content/barbers/babiy.png" />
            <span></span>
            <label>{{ $t('BarbersBlock.Barbers.K') }}&nbsp;{{ $t('BarbersBlock.Barbers.Klast') }}</label>
          </div>
        </div>


        <carousel
          class="barber-description"
          :perPageCustom="[[1, 1]]"
          :speed="800"
          :navigationEnabled="true"
          :navigationNextLabel="''"
          :navigationPrevLabel="''"
          :loop="true"
        >
          <!-- A -->
          <slide class="m-barb">
            <div class="barber">
              <img src="@/content/barbers/ovcharenko.png" />
            </div>
            <div class="desc">
              <h2>{{ $t('BarbersBlock.Barbers.A') }}<span></span><font>{{ $t('BarbersBlock.Barbers.Alast') }}</font></h2>
              <p>{{ $t('BarbersBlock.Barbers.Adesc') }}</p>
                
              <a href="https://widget.client.appointer.com.ua/uk/balls-barbershop?fbclid=IwAR1uafytri2ygW1kIHJ4TRVuRkZr9lLbZY6pZDB2zJ39rPecmRf6uf_B_cg" target="_blank" class="order-button">
                <span class="action">{{ $t('Buttons.MainButton') }}</span>
                <!-- <span class="service">YClients</span> -->
              </a>
            </div>
          </slide>

          <!-- B -->
          <slide class="m-barb">
            <div class="barber">
              <img src="@/content/barbers/mylik.png" />
            </div>
            <div class="desc">
              <h2>{{ $t('BarbersBlock.Barbers.B') }}<span></span><font>{{ $t('BarbersBlock.Barbers.Blast') }}</font></h2>
              <p>{{ $t('BarbersBlock.Barbers.Bdesc') }}</p>
                
              <a href="https://widget.client.appointer.com.ua/uk/balls-barbershop?fbclid=IwAR1uafytri2ygW1kIHJ4TRVuRkZr9lLbZY6pZDB2zJ39rPecmRf6uf_B_cg" target="_blank" class="order-button">
                <span class="action">{{ $t('Buttons.MainButton') }}</span>
                <!-- <span class="service">YClients</span> -->
              </a>
            </div>
          </slide>

          <!-- C -->
          <slide class="m-barb">
            <div class="barber">
              <img src="@/content/barbers/andreev.png" />
            </div>
            <div class="desc">
              <h2>{{ $t('BarbersBlock.Barbers.C') }}<span></span><font>{{ $t('BarbersBlock.Barbers.Clast') }}</font></h2>
              <p>{{ $t('BarbersBlock.Barbers.Cdesc') }}</p>
                
              <a href="https://widget.client.appointer.com.ua/uk/balls-barbershop?fbclid=IwAR1uafytri2ygW1kIHJ4TRVuRkZr9lLbZY6pZDB2zJ39rPecmRf6uf_B_cg" target="_blank" class="order-button">
                <span class="action">{{ $t('Buttons.MainButton') }}</span>
                <!-- <span class="service">YClients</span> -->
              </a>
            </div>
          </slide>

          <!-- D -->
          <slide class="m-barb">
            <div class="barber">
              <img src="@/content/barbers/patlan.png" />
            </div>
            <div class="desc">
              <h2>{{ $t('BarbersBlock.Barbers.D') }}<span></span><font>{{ $t('BarbersBlock.Barbers.Dlast') }}</font></h2>
              <p>{{ $t('BarbersBlock.Barbers.Ddesc') }}</p>
                
              <a href="https://widget.client.appointer.com.ua/uk/balls-barbershop?fbclid=IwAR1uafytri2ygW1kIHJ4TRVuRkZr9lLbZY6pZDB2zJ39rPecmRf6uf_B_cg" target="_blank" class="order-button">
                <span class="action">{{ $t('Buttons.MainButton') }}</span>
                <!-- <span class="service">YClients</span> -->
              </a>
            </div>
          </slide>

          <!-- E -->
          <slide class="m-barb">
            <div class="barber">
              <img src="@/content/barbers/shinkarenko.png" />
            </div>
            <div class="desc">
              <h2>{{ $t('BarbersBlock.Barbers.E') }}<span></span><font>{{ $t('BarbersBlock.Barbers.Elast') }}</font></h2>
              <p>{{ $t('BarbersBlock.Barbers.Edesc') }}</p>
                
              <a href="https://widget.client.appointer.com.ua/uk/balls-barbershop?fbclid=IwAR1uafytri2ygW1kIHJ4TRVuRkZr9lLbZY6pZDB2zJ39rPecmRf6uf_B_cg" target="_blank" class="order-button">
                <span class="action">{{ $t('Buttons.MainButton') }}</span>
                <!-- <span class="service">YClients</span> -->
              </a>
            </div>
          </slide>

          <!-- F -->
         

          <!-- G -->
          <slide class="m-barb">
            <div class="barber">
              <img src="@/content/barbers/bryantsev.png" />
            </div>
            <div class="desc">
              <h2>{{ $t('BarbersBlock.Barbers.G') }}<span></span><font>{{ $t('BarbersBlock.Barbers.Glast') }}</font></h2>
              <p>{{ $t('BarbersBlock.Barbers.Gdesc') }}</p>

              <a href="https://widget.client.appointer.com.ua/uk/balls-barbershop?fbclid=IwAR1uafytri2ygW1kIHJ4TRVuRkZr9lLbZY6pZDB2zJ39rPecmRf6uf_B_cg" target="_blank" class="order-button">
                <span class="action">{{ $t('Buttons.MainButton') }}</span>
                <!-- <span class="service">YClients</span> -->
              </a>
            </div>
          </slide>

          <!-- H -->
          <slide class="m-barb">
            <div class="barber">
              <img src="@/content/barbers/kniupa.png" />
            </div>
            <div class="desc">
              <h2>{{ $t('BarbersBlock.Barbers.H') }}<span></span><font>{{ $t('BarbersBlock.Barbers.Hlast') }}</font></h2>
              <p>{{ $t('BarbersBlock.Barbers.Hdesc') }}</p>

              <a href="https://widget.client.appointer.com.ua/uk/balls-barbershop?fbclid=IwAR1uafytri2ygW1kIHJ4TRVuRkZr9lLbZY6pZDB2zJ39rPecmRf6uf_B_cg" target="_blank" class="order-button">
                <span class="action">{{ $t('Buttons.MainButton') }}</span>
                <!-- <span class="service">YClients</span> -->
              </a>
            </div>
          </slide>


          <!-- I -->
          <slide class="m-barb">
            <div class="barber">
              <img src="@/content/barbers/kovalenko.png" />
            </div>
            <div class="desc">
              <h2>{{ $t('BarbersBlock.Barbers.I') }}<span></span><font>{{ $t('BarbersBlock.Barbers.Ilast') }}</font></h2>
              <p>{{ $t('BarbersBlock.Barbers.Idesc') }}</p>

              <a href="https://widget.client.appointer.com.ua/uk/balls-barbershop?fbclid=IwAR1uafytri2ygW1kIHJ4TRVuRkZr9lLbZY6pZDB2zJ39rPecmRf6uf_B_cg" target="_blank" class="order-button">
                <span class="action">{{ $t('Buttons.MainButton') }}</span>
                <!-- <span class="service">YClients</span> -->
              </a>
            </div>
          </slide>

          <!-- J -->
          <slide class="m-barb">
            <div class="barber">
              <img src="@/content/barbers/bogoboyashy.png" />
            </div>
            <div class="desc">
              <h2>{{ $t('BarbersBlock.Barbers.J') }}<span></span><font>{{ $t('BarbersBlock.Barbers.Jlast') }}</font></h2>
              <p>{{ $t('BarbersBlock.Barbers.Jdesc') }}</p>

              <a href="https://widget.client.appointer.com.ua/uk/balls-barbershop?fbclid=IwAR1uafytri2ygW1kIHJ4TRVuRkZr9lLbZY6pZDB2zJ39rPecmRf6uf_B_cg" target="_blank" class="order-button">
                <span class="action">{{ $t('Buttons.MainButton') }}</span>
                <!-- <span class="service">YClients</span> -->
              </a>
            </div>
          </slide>

          <!-- K -->
          <slide class="m-barb">
            <div class="barber">
              <img src="@/content/barbers/babiy.png" />
            </div>
            <div class="desc">
              <h2>{{ $t('BarbersBlock.Barbers.K') }}<span></span><font>{{ $t('BarbersBlock.Barbers.Klast') }}</font></h2>
              <p>{{ $t('BarbersBlock.Barbers.Kdesc') }}</p>

              <a href="https://widget.client.appointer.com.ua/uk/balls-barbershop?fbclid=IwAR1uafytri2ygW1kIHJ4TRVuRkZr9lLbZY6pZDB2zJ39rPecmRf6uf_B_cg" target="_blank" class="order-button">
                <span class="action">{{ $t('Buttons.MainButton') }}</span>
                <!-- <span class="service">YClients</span> -->
              </a>
            </div>
          </slide>


        </carousel>

      </div>
    </div>
  </section>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
import Lottie from '@/bm/lottie.vue';
import * as animationData from '@/bm/barbers/data.json';

export default {
  name: 'barbers-block',
  components: {
    Carousel,
    Slide,
    'lottie': Lottie
  },
  data() {
    return {
      defaultOptions: {animationData: animationData.default},
      animationSpeed: 1,
      NavNum: 0,
    }
  },
  methods: {
    changeNavNum: function () {
      this.$emit('changeNavNum', this.NavNum)
    },

    handleAnimation: function (anim) {
      this.anim = anim;
    },

    stop: function () {
      this.anim.stop();
    },

    play: function () {
      this.anim.play();
    },

    pause: function () {
      this.anim.pause();
    },

    onSpeedChange: function () {
      this.anim.setSpeed(this.animationSpeed);
    }
  },
  mounted() {
  }
}
</script>
